/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeriesPointDTO } from './SeriesPointDTO';
import {
    SeriesPointDTOFromJSON,
    SeriesPointDTOFromJSONTyped,
    SeriesPointDTOToJSON,
} from './SeriesPointDTO';

/**
 * 
 * @export
 * @interface SeriesValuesDTO
 */
export interface SeriesValuesDTO {
    /**
     * 
     * @type {Array<SeriesPointDTO>}
     * @memberof SeriesValuesDTO
     */
    values: Array<SeriesPointDTO>;
}

/**
 * Check if a given object implements the SeriesValuesDTO interface.
 */
export function instanceOfSeriesValuesDTO(value: object): value is SeriesValuesDTO {
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function SeriesValuesDTOFromJSON(json: any): SeriesValuesDTO {
    return SeriesValuesDTOFromJSONTyped(json, false);
}

export function SeriesValuesDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesValuesDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'values': ((json['values'] as Array<any>).map(SeriesPointDTOFromJSON)),
    };
}

export function SeriesValuesDTOToJSON(value?: SeriesValuesDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'values': ((value['values'] as Array<any>).map(SeriesPointDTOToJSON)),
    };
}

